import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateProductForLead as UpdateProductForLeadMutation,
    UpdateProductForLeadVariables,
    LeadProductUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_PRODUCT_FOR_LEAD from '../mutations/update-product-for-lead.graphql';

export const useUpdateProductForLead = (): {
    updateProductForLead: (input: LeadProductUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateProductForLead, {loading, error}] = useMutation<
        UpdateProductForLeadMutation,
        UpdateProductForLeadVariables
    >(UPDATE_PRODUCT_FOR_LEAD);

    return {
        updateProductForLead: (input: LeadProductUpdateInput) =>
            updateProductForLead({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
